import { MinMaxAge } from '@/modules/common/common/models/APP/MinMaxAge'

export class DentalMinMaxAges {
  holderInsured: MinMaxAge
  holderNotInsured: MinMaxAge
  insured: MinMaxAge
  constructor(data: any = {}) {
    this.holderInsured = new MinMaxAge(data.holderInsured)
    this.holderNotInsured = new MinMaxAge(data.holderNotInsured)
    this.insured = new MinMaxAge(data.insured)
  }
}
